import React from "react";
import Link from "helpers/link";
import Image from "components/image";

const SocialMedia = ({ data }) => (
    <div>
        { data.socialMedia.map((social, index) => (
            <Link className="footer-icon p-0 m-0 w-4" key={social._key} aria-label={`socialIcon-${index}`} to={social.url}>
                <Image image={social} />
            </Link>
        ))}
    </div>
);
export default SocialMedia;
